import {tracking as barkTrackingLogEvent, _t} from "@bark/bark-core";
import ReviewStars from "../review-stars";

export default function GroupRadioRatingsFilter(){

	const { Handlebars } = window;

    const hbTemplate = Handlebars.compile(document.getElementById('group-radio-ratings-filter-template').innerHTML);

    const stars = {
        "5-stars-only"   : {score: 5, suffix: _t('buyer_seller-list_filters:only-filter-suffix')},
        "4-stars-and-up" : {score: 4, suffix: _t('buyer_seller-list_filters:and-up-filter-suffix')},
        "3-stars-and-up" : {score: 3, suffix: _t('buyer_seller-list_filters:and-up-filter-suffix')},
        "2-stars-and-up" : {score: 2, suffix: _t('buyer_seller-list_filters:and-up-filter-suffix')},
        "1-stars-and-up" : {score: 1, suffix: _t('buyer_seller-list_filters:and-up-filter-suffix')},
    };

    const getHtml = (data) => {
        if(data.isPreview){
            data.data.previewChildren = addStarsHtmlToChildren(data.data.previewChildren);
        } else {
            data.data.children = addStarsHtmlToChildren(data.data.children);
        }
        return hbTemplate(data);
    };

    const registerListner = (eventEmitter, filterKey, group) => {
		$(`input[type=radio][name=${filterKey}]`).off('change').on('change', function (e) {
            setChecked($(this), filterKey);
			eventEmitter.emit('filters.mobile.changed', {filter: filterKey, group: group});

            barkTrackingLogEvent(
                'seller-list-&-profile',
                'seller_list_filters - Filter applied',
                {project_id: getProjectHash(), filter_name: filterKey, filter_value: getSelectedValue(filterKey)}
            );

		});
    };

    const getSelectedValue = (filterKey) => {
    	return $(`input[type=radio][name=${filterKey}]:checked`).val();
    };

    const disableFilter = (filterKey) => {
    	$(`input[type=radio][name=${filterKey}]`).attr('disabled', true);
        $(`.group-radio-${filterKey}`).addClass("disabled");
    };

    const enableFilter = (filterKey) => {
    	$(`input[type=radio][name=${filterKey}]`).attr('disabled', false);
    };

    const initFilter = (filterKey) => {
        let selectedOption = $(`input[type=radio][name=${filterKey}]:checked`);
        if(!selectedOption.length){
            selectedOption = $(`input[type=radio][name=${filterKey}][data-is-default-selected="true"]`);
            selectedOption.attr('checked', true);
            setChecked(selectedOption, filterKey);
        }
    };

    const addStarsHtmlToChildren = (children) => {
        return children.map((child) => {
            child.starsHtml = child.filter_id !== 'all' ? getReviewStarsHtml(child.filter_id) : '';
            return child;
        });
    };

    const getReviewStarsHtml = (filterId) => {
        return `<span>${ReviewStars().generateStars(stars[filterId].score)}</span><span class="ml-1 align-middle">${stars[filterId].suffix}</span>`;
    };

    const setChecked = ($option, filterKey) => {
        $(`.group-radio-${filterKey}`).removeClass("is-checked");
        $option.parent('label').addClass('is-checked');
    };

    const getProjectHash = () => {
        return $('#project-id').val();
    };

    return {
        getHtml,
        registerListner,
        getSelectedValue,
        disableFilter,
        enableFilter,
        initFilter
    };
}
